function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.33398 3.3339C3.5976 3.3339 3.00065 3.93086 3.00065 4.66724C3.00065 5.40362 3.5976 6.00057 4.33398 6.00057C5.07036 6.00057 5.66732 5.40362 5.66732 4.66724C5.66732 3.93086 5.07036 3.3339 4.33398 3.3339ZM0.333984 4.66724C0.333984 2.4581 2.12485 0.667236 4.33398 0.667236C6.54312 0.667236 8.33398 2.4581 8.33398 4.66724C8.33398 6.87638 6.54312 8.66724 4.33398 8.66724C2.12485 8.66724 0.333984 6.87638 0.333984 4.66724Z",
  fill: "#262BBA"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.6673 3.3339C16.9309 3.3339 16.334 3.93086 16.334 4.66724C16.334 5.40362 16.9309 6.00057 17.6673 6.00057C18.4037 6.00057 19.0007 5.40362 19.0007 4.66724C19.0007 3.93086 18.4037 3.3339 17.6673 3.3339ZM13.6673 4.66724C13.6673 2.4581 15.4582 0.667236 17.6673 0.667236C19.8765 0.667236 21.6673 2.4581 21.6673 4.66724C21.6673 6.87638 19.8765 8.66724 17.6673 8.66724C15.4582 8.66724 13.6673 6.87638 13.6673 4.66724Z",
  fill: "#262BBA"
});
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 9,
    viewBox: "0 0 22 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.4265c638609a19bfad220601e01e7b8c.svg";
export { ForwardRef as ReactComponent };